ready = ->
  $("body").on "click", ".add-deparment-btn", (e) ->
    $('#edit_deparment').addClass 'hide'
    $('#register_deparment').removeClass 'hide'

  $("body").on "click", ".edit-deparment-btn", (e) ->
    $('#edit_deparment').removeClass 'hide'
    $('#register_deparment').addClass 'hide'

$(document).on 'turbolinks:load', ready